import { FunctionComponent } from 'react'

import Text from '../Text'
import { ISliderProps } from './SliderComponenet.types'
import { Container, StyledSlider } from './styles'

const Slider: FunctionComponent<ISliderProps> = ({
  id,
  defaultValue,
  value,
  marks,
  max,
  min,
  step,
  valueLabelDisplay,
  label,
  valueLabelFormat,
  getAriaValueText,
  onChange,
}) => {
  return (
    <>
      {label && <Text>{label}</Text>}
      <Container valueLabelDisplay={valueLabelDisplay ?? 'on'}>
        <StyledSlider
          id={id}
          data-testid={`slider-componet-test-${id}`}
          value={value}
          defaultValue={defaultValue}
          getAriaValueText={getAriaValueText}
          valueLabelDisplay={valueLabelDisplay ?? 'on'}
          marks={marks}
          max={max}
          min={min}
          step={step}
          onChange={onChange}
          valueLabelFormat={valueLabelFormat && valueLabelFormat}
        />
      </Container>
    </>
  )
}

export default Slider
